'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var CURRENCY_FORMATS = [{ key: 'currency_format_1', value: '#.###,## CUR', description: '#.###,## CUR' }, { key: 'currency_format_2', value: '#,###.## CUR', description: '#,###.## CUR' }, { key: 'currency_format_3', value: 'CUR #.###,##', description: 'CUR #.###,##' }, { key: 'currency_format_4', value: 'CUR #,###.##', description: 'CUR #,###.##' }];

var DEFAULT = exports.DEFAULT = CURRENCY_FORMATS[1];
exports.default = CURRENCY_FORMATS;


//////////////////
// WEBPACK FOOTER
// ./src/constants/currencyFormats.js
// module id = 659
// module chunks = 0